'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var IconBase = require('@ali/vu-icon-base');

function Preview(props) {
  return React.createElement(
    IconBase,
    _extends({ viewBox: '0 0 1024 1024' }, props),
    React.createElement('path', { d: 'M512 864c-290.752 0-410.4-243.584-441.568-318.208a91.968 91.968 0 0 1 0-67.584C101.6 403.584 221.248 160 512 160c289.408 0 410.4 243.584 441.568 318.208 8.576 22.08 8.576 45.536 0 67.584C922.4 620.416 801.408 864 512 864zM129.984 500.48a30.4 30.4 0 0 0 0 21.664C156.16 588.48 261.6 800 512 800s355.84-211.52 382.016-276.48a30.4 30.4 0 0 0 0-21.664C867.84 435.52 762.4 224 512 224S156.16 435.52 129.984 500.48zM512 672c-88.192 0-160-72.32-160-160s71.808-160 160-160 160 72.32 160 160-71.808 160-160 160z m0-256c-52.608 0-96 42.88-96 96s42.88 96 96 96 96-42.88 96-96-43.392-96-96-96z' })
  );
}
Preview.displayName = 'Preview';

module.exports = Preview;


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-icons@4.1.6@@ali/ve-icons/build/svglib/preview.js
// module id = 204
// module chunks = 0